import React, { useEffect } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, FormControlLabel, FormHelperText,
  IconButton, InputLabel, MenuItem, Select, Switch, TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import { editUserSchema } from './userSchema';

const EditUserDialog = ({ open, onClose, user, onSave, saving, isSelf = false }) => {
  const formik = useFormik({
    initialValues: {
      name: user?.name ?? '',
      role: user?.role ?? 'user',
      is_active: user?.status === 'active',
    },
    validationSchema: editUserSchema,
    enableReinitialize: true,
    onSubmit: (values) => onSave(values),
  });

  useEffect(() => {
    if (!open) formik.resetForm();
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 1 }}>
        Edit User — {user?.name || user?.companyEmail}
        <IconButton size="small" onClick={onClose} disabled={saving}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />

        <FormControl fullWidth error={formik.touched.role && Boolean(formik.errors.role)} disabled={isSelf}>
          <InputLabel>Role</InputLabel>
          <Select
            name="role"
            value={formik.values.role}
            label="Role"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <MenuItem value="user">User</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
          </Select>
          {isSelf && <FormHelperText>You cannot change your own role.</FormHelperText>}
          {!isSelf && formik.touched.role && formik.errors.role && (
            <FormHelperText>{formik.errors.role}</FormHelperText>
          )}
        </FormControl>

        <FormControlLabel
          control={
            <Switch
              name="is_active"
              checked={formik.values.is_active}
              onChange={formik.handleChange}
              disabled={isSelf}
            />
          }
          label={isSelf ? 'Active (cannot change own status)' : (formik.values.is_active ? 'Active' : 'Inactive')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!formik.isValid || saving}
          onClick={formik.submitForm}
        >
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserDialog;
